{
  "lang": "nl",
  "alias": "rvr-schulden",
  "theme": "rvr",
  "master": "./masters/rvr/jumplist",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "bb-input-wrap-and-unit",
    "custom-checkboxes",
    "dialog",
    "final-node",
    "has-required",
    "heading2-3",
    "high-on-info-tb",
    "history",
    "md-labels",
    "model-filter",
    "modelitem",
    "no-login",
    "no-menu",
    "non-indenting-jumplist",
    "nonce-metatag",
    "nta:proxymap",
    "optional",
    "piwik-pro-nonce",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "selected-model",
    "show-server-side-validation",
    "showdown",
    "showdown-converter",
    "xsl-to-pdf"
  ],
  "overrideinloghtml": "schulden.html",
  "a11y": {
    "captions": false,
    "optionfieldsets": true,
    "strictlegends": true
  },
  "arbitrary": {
    "jumplisttitle": "Stappen:",
    "showdown": {
      "policy": "legacy"
    },
    "core": {
      "skipNumButtons": true
    },
    "previews": {
      "autoload": true,
      "singular": true,
      "showChanges": false
    },
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    }
  },
  "template": {
    "gatags": true,
    "logo": "logo-schulden",
    "header-lists-modelname": true,
    "less": {
      "post": [
        "jumplist.less"
      ]
    },
    "readonly-prop": "disabled"
  },
  "legacy": false
}
